module.exports = __webpack_public_path__ + "40ed4dc0ccddb7ae33dc627cc811a0cf.png";